/* unplugin-vue-components disabled */import script from "./principalSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./principalSheet.vue?vue&type=script&setup=true&lang=js"

import "./principalSheet.vue?vue&type=style&index=0&id=30af97ad&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30af97ad"]])

export default __exports__